export default function(totalCal) {
  return {
    type:"SET_TOTAL_CAL",
    totalCal
  }
}



// WEBPACK FOOTER //
// ./src/actions/setMacrosTotals/setCalTotal.js